/* Milda — interactions : apparition au défilement, menu mobile, galerie, sélecteur de variantes, quantité, barre d'achat mobile */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.m-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initNav() {
    var btn = document.querySelector('[data-m-burger]');
    var panel = document.getElementById('MildaMobileNav');
    if (!btn || !panel || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    btn.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.querySelector('[data-open]').hidden = open;
      btn.querySelector('[data-close]').hidden = !open;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) { btn.click(); btn.focus(); }
    });
  }

  function initGallery(root) {
    var track = root.querySelector('[data-m-track]');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = root.querySelectorAll('[data-m-go]');
    var dots = root.querySelectorAll('[data-m-dot]');
    var current = 0;

    function mark(i) {
      current = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.mGo, 10)); }); });
    var prev = root.querySelector('[data-m-prev]');
    var next = root.querySelector('[data-m-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) mark(Math.max(0, Math.min(slides.length - 1, i)));
      }, 80);
    }, { passive: true });
    return {
      showKey: function (key) {
        for (var n = 0; n < slides.length; n++) {
          if (slides[n].dataset.variantKey === key) { go(n); return; }
        }
      }
    };
  }

  function initProduct(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';
    var dataEl = root.querySelector('[data-m-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var gallery = initGallery(root);
    var idInput = root.querySelector('input[name="id"]');
    var submit = root.querySelector('.product-form__submit');
    var submitLabel = submit ? submit.querySelector('span') : null;
    var priceNow = root.querySelector('[data-m-price]');
    var priceWas = root.querySelector('[data-m-compare]');
    var stock = root.querySelector('[data-m-stock]');
    var chosen = root.querySelector('[data-m-chosen]');
    var sticky = document.querySelector('[data-m-sticky]');
    var strings = window.variantStrings || { addToCart: 'Ajouter au panier', soldOut: 'Épuisé' };

    function apply(v, updateUrl) {
      if (!v) return;
      idInput.value = v.id;
      idInput.disabled = !v.available;
      if (priceNow) priceNow.innerHTML = v.price;
      if (priceWas) { priceWas.innerHTML = v.compare || ''; priceWas.hidden = !v.compare; }
      if (chosen) chosen.textContent = v.title;
      if (stock) {
        stock.textContent = v.available ? stock.dataset.in : stock.dataset.out;
        stock.classList.toggle('is-out', !v.available);
      }
      if (submit) {
        if (v.available) { submit.removeAttribute('disabled'); if (submitLabel) submitLabel.textContent = strings.addToCart; }
        else { submit.setAttribute('disabled', 'disabled'); if (submitLabel) submitLabel.textContent = strings.soldOut; }
      }
      if (sticky) {
        sticky.querySelector('[data-m-sticky-name]').textContent = v.title;
        sticky.querySelector('[data-m-sticky-price]').innerHTML = v.price;
        var sb = sticky.querySelector('button');
        if (v.available) sb.removeAttribute('disabled'); else sb.setAttribute('disabled', 'disabled');
      }
      if (gallery && v.key) gallery.showKey(v.key);
      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('input[name="m-version"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var id = parseInt(radio.value, 10);
        apply(variants.filter(function (v) { return v.id === id; })[0], true);
      });
    });

    var qty = root.querySelector('[data-m-qty]');
    if (qty) {
      var input = qty.querySelector('input');
      qty.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          val = b.dataset.step === 'up' ? val + 1 : Math.max(1, val - 1);
          input.value = Math.min(val, 99);
        });
      });
    }

    if (sticky && submit && 'IntersectionObserver' in window) {
      sticky.querySelector('button').addEventListener('click', function () { submit.click(); });
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        sticky.querySelector('button').tabIndex = past ? 0 : -1;
      }).observe(submit);
    }
  }

  function boot(root) {
    initReveal(root);
    initNav();
    document.querySelectorAll('[data-m-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();